import styled from 'styled-components';
import media from '../../../styles/media.style';

import {
  BORDER_GRAY,
  BG_GRAY,
  NAVIGATION_MOBILE_HEIGHT,
  NAVIGATION_DESKTOP_HEIGHT,
} from '../../../styles/variables.style';

export const Wrapper = styled.div`
  flex-grow: 1;
  padding: 25px 16px;
  margin-top: ${NAVIGATION_MOBILE_HEIGHT}px;

  ${media.tabletP`
    margin-top: ${NAVIGATION_DESKTOP_HEIGHT}px;
  `};

  ${media.tabletP`
    padding: 25px 50px;
  `};
`;

export const Category = styled.div`
  margin-bottom: 30px;
  margin-right: 5px;
`;

export const CategoriesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const CategoriesWrapper = styled.div`
  flex: 3;
`;

export const CategoryName = styled.p`
  font-size: 10px;
  font-weight: 500;
  line-height: 1.2;
  letter-spacing: 0.1px;
  color: #9b9b9b;
  text-transform: uppercase;

  ${media.tabletP`
    font-size: 12px;
  `};
`;

export const Navigation = styled.div`
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.1px;
  line-height: 2.08;
  display: flex;

  ${media.tabletP`
    align-items: flex-end;
  `};
`;

export const NextPage = styled.span`
  text-transform: uppercase;

  ${media.tabletP`
    margin-left: auto;
    margin-right: 20px;
  `};
`;

export const CurrentPage = styled.span`
  text-transform: uppercase;
  text-decoration: underline;
  margin-right: 20px;
  order: -1;

  ${media.tabletP`
    order: 0;
    margin-right: 0;
  `};
`;

export const FlexSpace = styled.div`
  flex: 0;

  ${media.tabletP`
    flex: 1;
    margin-right: 30px;
    max-width: 170px;
  `};
`;

export const Hero = styled.div`
  width: 100%;
  margin: 5% auto 0;

  ${media.tabletP`
    width: 70%;
    margin-left: 200px;
  `};
`;

export const ImageContainer = styled.div`
  width: 170px;
  height: 170px;
  margin-right: 30px;
`;

export const Info = styled.h3`
  font-size: 12px;
  font-weight: 500;
  line-height: 1.17;
  letter-spacing: 0.1px;
  margin-top: 0;
  margin-bottom: 30px;
  text-transform: uppercase;

  ${media.tabletP`
    font-size: 16px;
    line-height: 1.5;
  `};
`;

export const LastVisit = styled.span`
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.1px;
`;

export const Name = styled.h1`
  font-size: 26px;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: 0.2px;
  text-transform: uppercase;

  ${media.tabletP`
    font-size: 36px;
    letter-spacing: 0.1px;
  `};
`;

export const Result = styled.div`
  padding: 14px;
  border: 3px solid ${BORDER_GRAY.COMMON_3};
  width: fit-content;
  min-width: 160px;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.1px;
  text-transform: uppercase;

  &:not(:last-child) {
    border-bottom: none;
  }

  ${media.tabletP`
    padding: 20px;
    font-size: 13px;
    font-weight: bold;
  `};
`;

export const ResultInline = styled.div`
  display: inline-block;
  padding: 14px;
  border: 3px solid ${BORDER_GRAY.COMMON_3};
  width: fit-content;
  min-width: 160px;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.1px;
  text-transform: uppercase;
  margin: 0 5px 5px 0;

  ${media.tabletP`
    padding: 20px;
    font-size: 13px;
    font-weight: bold;
  `};
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SectionContent = styled.div`
  display: flex;
  min-height: 264px;
`;

export const SectionTitle = styled.h5`
  flex: 3;
  text-transform: uppercase;
  margin-top: 0;
`;

export const Separator = styled.div`
  height: 1px;
  background-color: ${BG_GRAY.COMMON_5};
  margin: 20px 0 35px;
`;

export const TitleWrapper = styled.div`
  display: flex;
`;



// WEBPACK FOOTER //
// ./src/pages/StylistToolPages/ProfilePage/ProfilePage.style.js